/**
 * creates reducer with given metadata
 *
 * @param {object} metadata
 * @returns {function} (state: object, action: object) => object
 */
export default function createAvailableDatasetsReducer(metadata) {
    return () => metadata.datasets;
}
